import { i18n } from "@/i18n";
import { SIDENAV_GROUP_BY } from "@/constants";
import { PHISH_SERVICE, SEG_SERVICE } from "@/utils/services";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable: isQuarantineConfigurationAvailable } = useFlag(
  "QUARANTINE_CONFIGURATION",
);

export const MSP_NAV_ITEMS = [
  {
    order: 1,
    label: i18n.global.t("sidebar-email-security"),
    groupBy: SIDENAV_GROUP_BY.BETA,
    icon: "cb-icon-email",
    id: buildOrgUrl("msp", null, "email_security"),
    dataTestId: "msp-phish-titan",
    solutionId: PHISH_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-email-sec-overview"),
        id: buildOrgUrl("msp", null, "email_security/overview"),
        dataTestId: "msp-email_security-overview",
      },
      {
        label: i18n.global.t("sidebar-email-history"),
        id: buildOrgUrl("msp", null, "email_security/email-history"),
        dataTestId: "msp-email_security-email_history",
      },
      {
        label: i18n.global.t("sidebar-quarantine"),
        id: buildOrgUrl("msp", null, "email_security/quarantine"),
        dataTestId: "msp-email_security-quarantine",
        solutionId: SEG_SERVICE,
      },

      {
        label: i18n.global.t("sidebar-incidents"),
        id: buildOrgUrl("msp", null, "email_security/incidents"),
        dataTestId: "msp-email_security-incidents",
        permanentPill: { variant: "infoFull", text: i18n.global.t("AI") },
      },
      {
        label: i18n.global.t("sidebar-configuration"),
        id: buildOrgUrl("msp", null, "email_security/configuration"),
        dataTestId: "msp-email_security-configuration",
        hasEvent: true,
        children: [
          {
            label: i18n.global.t("sidebar-mail-flow"),
            id: buildOrgUrl(
              "msp",
              null,
              "email_security/configuration/mail_flow",
            ),
            dataTestId: "msp-email_security-configuration-mail-flow",
          },
          {
            label: i18n.global.t("page-title-exemptions"),
            id: buildOrgUrl(
              "msp",
              null,
              "email_security/configuration/exemptions",
            ),
            dataTestId: "msp-mail-flow-tab-exemptions",
          },
          ...(isQuarantineConfigurationAvailable.value
            ? [
                {
                  label: i18n.global.t("page-title-quarantine"),
                  id: buildOrgUrl(
                    "msp",
                    null,
                    "email_security/configuration/quarantine",
                  ),
                  dataTestId: "msp-mail-flow-tab-quarantine",
                  solutionId: SEG_SERVICE,
                },
              ]
            : []),
          {
            label: i18n.global.t("page-title-block-list"),
            id: buildOrgUrl(
              "msp",
              null,
              "email_security/configuration/block_list",
            ),
            dataTestId: "msp-mail-flow-tab-block-list",
            solutionId: SEG_SERVICE,
          },
          {
            label: i18n.global.t("page-title-link-lock"),
            id: buildOrgUrl(
              "msp",
              null,
              "email_security/configuration/link_lock",
            ),
            dataTestId: "msp-email_security-configuration-link-lock",
          },
        ],
      },
      {
        label: i18n.global.t("sidebar-notifications"),
        id: buildOrgUrl("msp", null, "email_security/notifications"),
        dataTestId: "msp-email_security-notifications",
      },
      {
        label: i18n.global.t("sidebar-reports"),
        id: buildOrgUrl("msp", null, "email_security/reports"),
        dataTestId: "msp-email_security-reports",
        hasEvent: true,
        children: [
          {
            label: i18n.global.t("sidebar-summary"),
            id: buildOrgUrl("msp", null, "email_security/reports/summary"),
            dataTestId: "msp-email_security-reports-summary",
          },
          {
            label: i18n.global.t("sidebar-insights"),
            id: buildOrgUrl("msp", null, "email_security/reports/insights"),
            dataTestId: "msp-email_security-reports-insights",
          },
        ],
      },
    ],
  },
];

export const CUSTOMER_NAV_ITEMS = [
  {
    order: 1,
    label: i18n.global.t("sidebar-email-security"),
    groupBy: SIDENAV_GROUP_BY.BETA,
    icon: "cb-icon-email",
    id: buildOrgUrl("customer", null, "email_security"),
    dataTestId: "customer-phish-titan",
    solutionId: PHISH_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-email-sec-overview"),
        id: buildOrgUrl("customer", null, "email_security/overview"),
        dataTestId: "customer-email_security-overview",
      },

      {
        label: i18n.global.t("sidebar-email-history"),
        id: buildOrgUrl("customer", null, "email_security/email-history"),
        dataTestId: "customer-email_security-email_history",
      },

      {
        label: i18n.global.t("sidebar-quarantine"),
        id: buildOrgUrl("customer", null, "email_security/quarantine"),
        dataTestId: "customer-email_security-quarantine",
        solutionId: SEG_SERVICE,
      },
      {
        label: i18n.global.t("sidebar-incidents"),
        id: buildOrgUrl("customer", null, "email_security/incidents"),
        dataTestId: "customer-email_security-incidents",
        permanentPill: { variant: "infoFull", text: i18n.global.t("AI") },
      },
      {
        label: i18n.global.t("sidebar-domains"),
        id: buildOrgUrl("customer", null, "email_security/domains"),
        dataTestId: "customer-email_security-domains",
        solutionId: SEG_SERVICE,
      },
      {
        label: i18n.global.t("sidebar-configuration"),
        id: buildOrgUrl("customer", null, "email_security/configuration"),
        disabled: false,
        dataTestId: "customer-email_security-configuration",
        hasEvent: true,
        children: [
          {
            label: i18n.global.t("sidebar-mail-flow"),
            id: buildOrgUrl(
              "customer",
              null,
              "email_security/configuration/mail_flow",
            ),
            dataTestId: "customer-email_security-configuration-mail-flow",
          },
          {
            label: i18n.global.t("page-title-exemptions"),
            id: buildOrgUrl(
              "customer",
              null,
              "email_security/configuration/exemptions",
            ),

            dataTestId: "customer-mail-flow-tab-exemptions",
          },
          ...(isQuarantineConfigurationAvailable.value
            ? [
                {
                  label: i18n.global.t("page-title-quarantine"),
                  id: buildOrgUrl(
                    "customer",
                    null,
                    "email_security/configuration/quarantine",
                  ),
                  dataTestId: "customer-mail-flow-tab-quarantine",
                  solutionId: SEG_SERVICE,
                },
              ]
            : []),
          {
            label: i18n.global.t("page-title-block-list"),
            id: buildOrgUrl(
              "customer",
              null,
              "email_security/configuration/block_list",
            ),
            dataTestId: "customer-mail-flow-tab-block-list",
            solutionId: SEG_SERVICE,
          },
          {
            label: i18n.global.t("page-title-link-lock"),
            id: buildOrgUrl(
              "customer",
              null,
              "email_security/configuration/link_lock",
            ),
            dataTestId: "customer-email_security-link-lock",
          },
        ],
      },
      {
        label: i18n.global.t("sidebar-notifications"),
        id: buildOrgUrl("customer", null, "email_security/notifications"),
        dataTestId: "customer-email_security-notifications",
      },
      {
        label: i18n.global.t("sidebar-reports"),
        id: buildOrgUrl("customer", null, "email_security/reports"),
        dataTestId: "customer-email_security-reports",
        hasEvent: true,
        children: [
          {
            label: i18n.global.t("sidebar-summary"),
            id: buildOrgUrl("customer", null, "email_security/reports/summary"),
            dataTestId: "customer-email_security-reports-summary",
          },
          {
            label: i18n.global.t("sidebar-insights"),
            id: buildOrgUrl(
              "customer",
              null,
              "email_security/reports/insights",
            ),
            dataTestId: "customer-email_security-reports-insights",
          },
        ],
      },
    ],
  },
];

export default {};
